import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import * as _ from 'lodash';

// data, models, helpers
import { segmentAnimation } from '../base/animations';
import { StatusModel } from 'shared/search/status.model';

// components
import { BaseSegmentComponent } from '../base/_base-segment.component';
import { FitmentsSearchComponent } from './fitments-search/fitments-search.component';

// services
import { BrandService } from 'shared/brand/brand.service';
import { ScorecardConnectorService } from 'shared/scorecard/scorecard-connector.service';
import { FitmentsScorecardService } from '../segments-scorecard/fitments-scorecard/fitments-scorecard.service';
import {takeWhile} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'fitments-segment',
  templateUrl: 'fitments.component.html',
  styleUrls: ['../base/_base-segment.component.scss', 'fitments.component.scss'],
  animations: [segmentAnimation],
})
export class FitmentsComponent extends BaseSegmentComponent implements OnInit {

  segmentName: string = 'fitments';

  @ViewChild(FitmentsSearchComponent, {static: true})
  fitmentsSearch: FitmentsSearchComponent | void;

  // after fitment change we save refision id
  get isDirty(): boolean {
    return !!this.revisionId;
  }

  get isResearchMode(): boolean {
    return _.get(this.fitmentsSearch, 'isResearchMode', false);
  }

  // indicate changes in the fitments
  // used for canceling changes
  get revisionId(): any {
    return _.get(this.fitmentsSearch, 'revisionId');
  }

  constructor(
    protected ref: ChangeDetectorRef,
    protected scorecardConnectorService: ScorecardConnectorService,
    protected brandService: BrandService,
    protected fb: UntypedFormBuilder,
    private fitmentsScorecardService: FitmentsScorecardService,
  ) {
    super(ref, scorecardConnectorService, brandService, fb);
  }

  ngOnInit() {
    super.ngOnInit();
    this.fitmentsScorecardService.statusFilterChanged
    .pipe(takeWhile(() => this.isActive))
    .subscribe((status: StatusModel) => {
      if (this.fitmentsSearch instanceof FitmentsSearchComponent) {
        this.fitmentsSearch.filterByStatus(status);
      }
    });
    this.runAnimation('show');
  }

  /*
    * Fake save method
    * Removes revisionId
   */
  public save(): void {
    if (this.fitmentsSearch instanceof FitmentsSearchComponent) {
      this.fitmentsSearch.resetRevisionId();
    }
    this.ref.markForCheck();
  }

  public fetchFitments(): void {
    if (this.fitmentsSearch instanceof FitmentsSearchComponent) {
      this.fitmentsSearch.fetchFitments();
    }
  }

  protected setData(itemDetail: any) {}
}
